export default __webpack_public_path__ + "static/media/p2.a15c9c2d.png";